import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, Text } from '@chakra-ui/react';
export function InfoItem(props) {
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    alignItems: props.horizontal ? 'baseline' : '',
    direction: props.horizontal ? 'row' : 'column',
    children: [/*#__PURE__*/_jsx(Text, {
      fontWeight: "bold",
      fontSize: "label",
      lineHeight: "16px",
      textTransform: "uppercase",
      color: "text.secondary",
      mb: "3px",
      mr: props.horizontal ? '4px' : '',
      children: props.label
    }), /*#__PURE__*/_jsx(Text, {
      fontWeight: "normal",
      fontSize: props.horizontal ? '12px' : '15px',
      lineHeight: "20px",
      color: "text.primary",
      textAlign: "start",
      children: props.value
    })]
  });
}